import React from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import FormLabel from "@material-ui/core/FormLabel";

import Button from "common/components/CustomButtons/Button.jsx";

// @material-ui/core components
import Voicemail from "@material-ui/icons/Voicemail";

import loadContent from "core-module/hoc/loadContent";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  datainfo: {
    ...importedStyle.cardTitle,
    textAlign: "right",
    paddingRight: "20px",
    fontSize: "18px"
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  labelHorizontal: {
    justifyContent: "center",
    fontSize: "15px"
  },
  containerLine: {
    marginTop: "20px"
  },
  email: {
    ...importedStyle.cardTitle,
    textAlign: "right",
    paddingRight: "20px",
    fontSize: "14px"
  },
  editButton: {
    textAlign: "right",
    margin: "10px"
  }
};

const VoicemailSettings = props => {
  const { classes } = props;
  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <Voicemail />
        </CardIcon>
        <h4 className={classes.cardIconTitle}> Voicemail Settings</h4>
      </CardHeader>
      <CardBody>
        <GridContainer className={classes.containerLine} alignItems="center">
          <GridItem xs={6}>
            <FormLabel className={classes.labelHorizontal}>
              Voicemail Status
            </FormLabel>
          </GridItem>
          <GridItem xs={6}>
            <h5 className={classes.datainfo}>
              {props.getData("vm_enable", "display")}
            </h5>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.containerLine} alignItems="center">
          <GridItem xs={6}>
            <FormLabel className={classes.labelHorizontal}>
              Voicemail Password
            </FormLabel>
          </GridItem>
          <GridItem xs={6}>
            <h5 className={classes.datainfo}>******</h5>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.containerLine} alignItems="center">
          <GridItem xs={6}>
            <FormLabel className={classes.labelHorizontal}>
              Send e-mail notification
            </FormLabel>
          </GridItem>
          <GridItem xs={6}>
            <h5 className={classes.datainfo}>
              {props.getData("vm_sendemail")}
            </h5>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.containerLine} alignItems="center">
          <GridItem xs={6}>
            <FormLabel className={classes.labelHorizontal}>
              Notification E-mail Address
            </FormLabel>
          </GridItem>
          <GridItem xs={6}>
            <h5 className={classes.email}>{props.getData("vm_email")}</h5>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.containerLine} alignItems="center">
          <GridItem xs={6}>
            <FormLabel className={classes.labelHorizontal}>
              Attach soundfile to e-mail
            </FormLabel>
          </GridItem>
          <GridItem xs={6}>
            <h5 className={classes.datainfo}>
              {props.getData("vm_emailattachfile", "display")}
            </h5>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.containerLine} alignItems="flex-end">
          <GridItem className={classes.editButton} xs={12}>
            <Button
              color="primaryLightBlue"
              onClick={() =>
                props.onClickEditVoicemailSettings(
                  props.getData("billingpackageserviceid")
                )
              }
            >
              Edit
            </Button>
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
};

export default withStyles(styles)(
  loadContent(
    "user.session/billingpackage.props/voipfeatures",
    VoicemailSettings
  )
);
